import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import css from 'styles/components/account/breadcrumb.scss';

const Breadcrumb = ({ items }, { testId }) => (
  <nav aria-label="breadcrumb">
    <ol className={css.breadcrumb}>
      <li className={css.breadcrumbItem}>
        <MartyLink to="/account" data-test-id={testId('accountOverviewBreadcrumb')}>Account Overview</MartyLink>
      </li>
      {items.map(({ name, url }, index) => {
        const isLastItem = index === items.length - 1;
        return (
          <li key={index} className={css.breadcrumbItem}>
            {isLastItem ?
              <span data-test-id={testId('currentBreadcrumb')}>{name}</span> :
              <MartyLink to={url} data-test-id={testId('breadcrumb')}>{name}</MartyLink>}
          </li>
        );
      })}
    </ol>
  </nav>
);

Breadcrumb.contextTypes = {
  testId: PropTypes.func
};

Breadcrumb.propTypes = {
  items: PropTypes.array.isRequired
};

export default Breadcrumb;
